import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { EcomHttpClient } from '@wix/wixstores-client-storefront-sdk';
import { CheckoutSettingsApi } from '../apis/CheckoutSettingsApi';
import { ECOM_PLATFORM_APP_DEF_ID } from '../../utils/consts';
const origin = 'express-checkout';
export class CheckoutSettingsService {
  constructor(controllerConfig) {
    _defineProperty(this, "checkoutSettingsApi", void 0);
    _defineProperty(this, "wixCodeApi", void 0);
    const siteStore = new EcomHttpClient({
      wixCodeApi: controllerConfig.wixCodeApi,
      instance: controllerConfig.appParams.instance,
      storeId: controllerConfig.appParams.instanceId,
      csrfToken: controllerConfig.csrfToken,
      essentials: controllerConfig.essentials,
      isSSR: controllerConfig.wixCodeApi.window.rendering.env === 'backend',
      experiments: controllerConfig.essentials.experiments
    });
    this.wixCodeApi = controllerConfig.wixCodeApi;
    this.checkoutSettingsApi = new CheckoutSettingsApi({
      siteStore,
      origin
    });
    controllerConfig.wixCodeApi.site.onInstanceChanged(_ref => {
      let {
        instance
      } = _ref;
      siteStore.instanceManager.setInstance(instance);
    }, ECOM_PLATFORM_APP_DEF_ID);
  }
  async getSiteSettings() {
    return this.checkoutSettingsApi.getCheckoutSettings();
  }
  async getExpressCheckoutSettings() {
    const api = await this.wixCodeApi.site.getPublicAPI(ECOM_PLATFORM_APP_DEF_ID);
    return api.__internal.expressCheckout.settings();
  }
}
//# sourceMappingURL=CheckoutSettingsService.js.map